var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-field",
    {
      attrs: {
        error: _vm.errors.has("customer"),
        "error-label": _vm.errors.first("customer")
      }
    },
    [
      _c(
        "q-search",
        _vm._b(
          {
            class: { "no-shadow": _vm.noShadow },
            attrs: {
              name: "customer-search",
              placeholder: _vm.$tc("customer", 1)
            },
            model: {
              value: _vm.customerInput,
              callback: function($$v) {
                _vm.customerInput = $$v
              },
              expression: "customerInput"
            }
          },
          "q-search",
          _vm.$attrs,
          false
        ),
        [
          _c("infinite-autocomplete", {
            ref: "autocomplete",
            attrs: {
              debounce: _vm.defaultSearchDebounce,
              "min-characters": 0,
              "max-results": 200,
              "max-height": "300px",
              "value-field": function(v) {
                return _vm.getCustomerName(v.value)
              }
            },
            on: {
              fetch: _vm.handleInfiniteScroll,
              search: _vm.handleSearch,
              selected: _vm.handleSelect
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }